import { render } from "./RedButton.vue?vue&type=template&id=b89b2df8"
import script from "./RedButton.vue?vue&type=script&lang=js"
export * from "./RedButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__